<ng-container *ngIf="initialized && !$hasMissingRequiredInParams">
  <datex-wizard [stepConfigs]="getStepConfigs()" (finish)="finish()" (close)="close()" (commandsTmpRef)="commandsTmpRefChange($event)" [stepsResultFunc]="stepsResultFunc.bind(this)"></datex-wizard>
</ng-container>

<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
